import * as React from "react"
import { Action, ActionAnchor } from "@tenforce/toolbox-button-push-react"
import { Symbols } from "@tenforce/toolbox-fontmap"
import { Labels } from "../../../util/Translations"

interface Props {
    helpUrl: string
    showDictionary: () => void
    supportMailAddress: string
}

export const BottomBar = ({
    helpUrl,
    showDictionary,
    supportMailAddress,
}: Props): JSX.Element => {
    const { ContactSupport, Dictionary, FullDocumentation } = Labels
    const isHelpVisible = helpUrl.length > 0
    const isSupportLinkVisible = supportMailAddress.length > 0

    return (
        <div className="tw-flex tw-w-full tw-justify-center tw-fixed tw-bottom-5 tw-z-0">
            <div className="bg-white tw-rounded-full tw-px-4 tw-py-2 tw-mx-2">
                <Action
                    onClick={showDictionary}
                    data-ft-component="dictionary-button"
                    extraClasses="text-black"
                >
                    {Symbols.OpenBook}&nbsp;
                    <span className="theme-link">{Dictionary}</span>
                </Action>
            </div>

            <div className="bg-white tw-rounded-full tw-px-4 tw-py-2 tw-mx-2">
                {isHelpVisible && (
                    <ActionAnchor
                        extraClasses="text-black"
                        href={helpUrl}
                        target="_blank"
                        data-ft-component="documentation-link"
                    >
                        {Symbols.Instructions}&nbsp;
                        <span className="theme-link">{FullDocumentation}</span>
                    </ActionAnchor>
                )}

                {isHelpVisible && isSupportLinkVisible && (
                    <div className="separator"></div>
                )}

                {isSupportLinkVisible && (
                    <ActionAnchor
                        extraClasses="text-black"
                        href={`mailto:${supportMailAddress}`}
                        target="_blank"
                        data-ft-component="support-mail"
                    >
                        {Symbols.Email}&nbsp;
                        <span className="theme-link">{ContactSupport}</span>
                    </ActionAnchor>
                )}
            </div>
        </div>
    )
}

export default BottomBar
